import { useGetDatapointsRequestDashboardParams } from "./widget-data/use-datapoints";
export const useGetCommentRequest = (widgetId) => {
    const dp = useGetDatapointsRequestDashboardParams(true, undefined, undefined);
    return {
        entityId: dp?.entityId,
        entityType: dp?.entityType,
        referenceDate: dp?.asOfDate,
        relationId: dp?.selectedFundId ?? (dp?.enabled ? dp?.selectedInvestorId : undefined),
        widgetId
    };
};
